import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
	selector: 'app-aps-vtb-mortgage-delete-modal',
	templateUrl: './vtb-mortgage-delete-modal.component.html',
	standalone: false,
})
export class VtbMortgageDeleteModalComponent {
	constructor(
		private matDialogRef: MatDialogRef<VtbMortgageDeleteModalComponent>,
	) {}

	onDelete() {
		this.matDialogRef.close(true);
	}
}
